import React from "react";
import { Ban, CheckCircle2, Trash2, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { IconAction } from "@/components/shared/IconAction";
import { cn } from "@/lib/utils";

interface BulkActionsProps {
  selectedCount: number;
  onApprove?: () => void;
  onReject?: () => void;
  onDelete?: () => void;
  onClear: () => void;
  showApprove?: boolean;
  showReject?: boolean;
  showDelete?: boolean;
  className?: string;
}

const BulkActions: React.FC<BulkActionsProps> = ({
  selectedCount,
  onApprove,
  onReject,
  onDelete,
  onClear,
  showApprove = true,
  showReject = true,
  showDelete = true,
  className,
}) => {
  if (selectedCount === 0) return null;

  return (
    <div
      role="toolbar"
      aria-label="Bulk actions"
      className={cn(
        "mb-4 flex flex-wrap items-center gap-3 rounded-md border border-border bg-muted px-3 py-2",
        className,
      )}
    >
      <span className="text-sm font-medium tabular-nums text-foreground">
        {selectedCount} selected
      </span>

      <div className="flex flex-1 flex-wrap gap-2">
        {showApprove && onApprove && (
          <Button size="sm" onClick={onApprove} title="Approve selected">
            <CheckCircle2 />
            Approve
          </Button>
        )}

        {showReject && onReject && (
          <Button size="sm" variant="destructive-outline" onClick={onReject} title="Reject selected">
            <Ban />
            Reject
          </Button>
        )}

        {showDelete && onDelete && (
          <Button size="sm" variant="outline" onClick={onDelete} title="Delete selected">
            <Trash2 />
            Delete
          </Button>
        )}
      </div>

      <IconAction label="Clear selection" icon={<X />} onClick={onClear} />
    </div>
  );
};

export default BulkActions;
